import { useDispatch, useSelector } from "react-redux"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { clearDataFO, getFieldOfficerList } from "../../../../redux/actions/FieldOfficerAction.jsx"
import TableView, { formatterRowComponent } from "../../../../component/atoms/Tabel/index.jsx"
import { sortCaret } from "../../../../_metronic/_helpers/index.js"
import { Card, CardBody } from "../../../../_metronic/_partials/controls/index.js"
import { useSubheader } from "../../../../_metronic/layout/index.js"
import { DetailSvgIcon, EditSvgIcon } from "../../../../component/atoms/Icons/SVG/index.jsx"
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap"
import { EmptyCard, Search, TableSkeleton } from "../../../../component/index.jsx"
import { Popup } from "../../../../component/atoms/Popup/index.jsx"
import { loadUserLogin } from "../../../service/userManagementAction.js"
import { linkWithCtrl } from "../../../helpers/Utils.js"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { useLocation } from "react-router"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { useUrlParam } from "../../../hooks/useUrlParams.jsx"
import {
  DATE_TYPE_ENUM,
  FIELD_OFFICER_ROLE_ENUM,
  ROUTING_STATUS
} from "../../../../constants/StringConstant.js"
import { useTranslation } from "react-i18next"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { stringFormatting } from "../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../helpers/DateHelper"

export const ListFieldOfficer = ({ history }) => {
  const privileges = loadUserLogin().privilege
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { General, FieldOfficer } = useSelector((state) => state)
  const formRef = useRef()
  const location = useLocation()

  const [search, setSearch] = useState({
    keyword: ""
  })
  const [isFilter, setIsFilter] = useState(false)
  const [showPopupError, setShowPopupError] = useState(false)
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [queryStringObj, setQueryStringObj] = useState(undefined)

  const urlParam = useUrlParam()

  useEffect(() => {
    dispatch(clearDataFO())
  }, [])

  useEffect(() => {
    subHeader.setButton(false)
    subHeader.setTitle(t("sub_header_fo"))
  }, [dispatch])

  const changePage = useCallback(
    (param) => {
      let newParam
      if (param.sortField != null) {
        newParam = getUrlParsingPageFilter({
          ...search,
          ...param,
          sort: param.sortField + "," + param.sortOrder
        })
      } else {
        newParam = getUrlParsingPageFilter({
          ...search,
          ...param
        })
      }
      history.push({ pathname: location.pathname, search: newParam })
    },
    [search]
  )

  const handleResetSearch = () => {
    urlParam.resetKeyword()
    setSearch({ keyword: "" })
    setIsFilter(false)
  }

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])
  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
  }, [queryStringObj])
  useEffect(() => {
    const result = location?.search
    setQueryStringObj(urlParam.getUrlParamsObj)
    fetchData(result)
  }, [location.search, urlParam.getUrlParamsObj])
  useEffect(() => {
    if (isFilter) {
      if (FieldOfficer.pageData.length === 0) {
        setShowPopupError(true)
      }
    }
  }, [FieldOfficer.pageData])

  const uiName = (e) => {
    return (
      <>
        <span className="text-dark font-weight-bolder mb-1 font-size-lg">
          {stringFormatting(e?.name)}
        </span>
        <span className="text-muted font-weight-bold d-block">
          {stringFormatting(e?.phone_number)}
        </span>
      </>
    )
  }

  const uiStatus = (e) => {
    return (
      <Badge
        variant={e?.status_enum === ROUTING_STATUS.STATUS_ENUM.ACTIVE ? "primary" : "secondary"}>
        {stringFormatting(e.status_string)}
      </Badge>
    )
  }

  const uiCode = (e) => {
    return (
      <>
        <span className="text-dark font-weight-bolder mb-1 font-size-lg">
          {stringFormatting(e?.code)}
        </span>
      </>
    )
  }

  const uiCreateDate = (e) => {
    return (
      <>
        {stringFormatting(timeStampToDate(e.created_date, DATE_TYPE_ENUM.ISO_DATE_STRAP))}
        <br />
        {stringFormatting(timeStampToDate(e.created_date, DATE_TYPE_ENUM.ISO_TIME_STRAP))}
      </>
    )
  }

  const uiAction = (e) => {
    return (
      <div>
        {privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() =>
                history.push(
                  RoutesConstants.FIELD_OFFICER.DETAIL_FO(
                    FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER,
                    e.id
                  )
                )
              }>
              <DetailSvgIcon />
            </div>
          </OverlayTrigger>
        )}
        {privileges.indexOf(PRIVILEGE_ENUM.EDIT_FIELD_OFFICER) > -1 && (
          <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}>
            <div
              className="btn btn-icon btn-detail btn-hover-secondary btn-sm mx-3"
              onClick={() => history.push(RoutesConstants.FIELD_OFFICER.EDIT_FO(e.id))}>
              <EditSvgIcon />
            </div>
          </OverlayTrigger>
        )}
      </div>
    )
  }

  const columns = [
    {
      dataField: "code",
      text: "ID FO",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "10%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "name",
      text: t("table_header_name").toUpperCase(),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiName
      },
      sortCaret: sortCaret
    },
    {
      dataField: "sub_regional",
      text: t("table_header_sub_regional").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => <span>{stringFormatting(e?.sub_regional)}</span>
      }
    },
    {
      dataField: "base_code",
      text: t("table_header_base_name").toUpperCase(),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <span className={"font-weight-bolder"}>{stringFormatting(e?.base_code)}</span>
            <span className="text-muted font-weight-bold d-block">
              {stringFormatting(e?.base_address)}
            </span>
          </>
        )
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiStatus
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date").toUpperCase(),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCreateDate
      },
      sortCaret: sortCaret,
      headerStyle: () => {
        return { width: "10%" }
      }
    },
    {
      dataField: "action",
      text: "Action",
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      },
      headerStyle: () => {
        return { width: "10%" }
      }
    }
  ]

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  function fetchData(param) {
    return dispatch(getFieldOfficerList(param))
  }

  function onSearch(value) {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
    let param = {
      keyword: value.keyword
    }
    const url = urlParam.stringifyObj(param)
    history.push({ pathname: location.pathname, search: url })
  }

  return (
    <>
      <Popup
        type={"empty"}
        body={<span>{t("placeholder_empty_data")}</span>}
        centered={true}
        persistent={true}
        show={showPopupError}
        onClick={() => {
          setShowPopupError(false)
        }}
      />
      <div className="filter-container">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-10">
          <Search
            // seacrh
            isActiveSearch={isActiveSearch}
            placeholder={t("placeholder_enter_fo_name")}
            onSubmitForm={onSearch}
            initialValues={search}
            name={"keyword"}
            innerRef={formRef}
            trigerReset={handleResetSearch}
          />
        </div>
      </div>
      <Card>
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : FieldOfficer?.pageData?.length == 0 ? (
            <EmptyCard
              image={
                isActiveSearch
                  ? ILLUSTRATION_CONSTANTS.NOT_FOUND_DATA
                  : ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA
              }
              body={
                isActiveSearch
                  ? t("messages_response_your_search_was_not_found")
                  : t("messages_response_empty_state", { name: t("sub_header_fo") })
              }
              subtitle={isActiveSearch ? t("messages_response_search_not_found_subtitle") : ""}
            />
          ) : (
            ""
          )}
          <TableView
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            dataTable={FieldOfficer?.pageData ?? []}
            currentPage={FieldOfficer?.page?.currentPage ?? 1}
            currentElement={FieldOfficer?.page?.currentElement ?? 10}
            totalCount={FieldOfficer?.page?.totalCount ?? 0}
            loadingGetData={General.loading}
            rowClasses={() => {
              return "cursor-pointer"
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_FIELD_OFFICER) > -1) {
                  if (e.target.cellIndex < 6) {
                    const url = RoutesConstants.FIELD_OFFICER.DETAIL_FO(
                      FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER,
                      row.id
                    )
                    if (e.ctrlKey) {
                      linkWithCtrl(url)
                    } else {
                      history.push(url)
                    }
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}